// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xi_a bhj_a bhj_x","StrollerDetailRating__muted":"xi_b bhj_fm"};